export const environment = {
  production: false,
  //apiUrl: 'http://localhost:5018/api/v1',
  apiUrl: 'https://api.wallety.me/api/v1',
  apiKey: '',//43ed8450-d4df-4ae7-a474-3f4b8e312eb2
  whatsapp_url: 'https://wa.me/27773762687'
};